import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="workspaces--workspace-picker"
export default class extends Controller {
  static targets = ["anchor", "redirect"]

  connect() {
    this._redirectHandler = (event) => this.changeWorkingAccount(event)
    this.redirectTargets.forEach((link) => {
      link.addEventListener("click", this._redirectHandler)
    })
  }

  disconnect() {
    if (this._redirectHandler) {
      this.redirectTargets.forEach((link) => {
        link.removeEventListener("click", this._redirectHandler)
      })
    }
  }
  changeWorkingAccount(event) {
    event.preventDefault()

    const anchor = event.target.closest("a")
    if (!anchor) {
      console.error("Failed to find anchor element.")
      return
    }

    const selectedWorkspaceId = anchor.getAttribute("data-workspace-id")
    if (!selectedWorkspaceId) {
      console.error("Failed to retrieve workspace ID.")
      return
    }

    let new_path = "/"

    if (selectedWorkspaceId !== "new") {
      const path = window.location.pathname
      const segments = path.split("/")

      if (path === "/" || Number.isNaN(Number(segments[1]))) {
        new_path += `${selectedWorkspaceId}/invoices`
      } else if (segments[3] && !Number.isNaN(Number(segments[3]))) {
        new_path += `${selectedWorkspaceId}/${segments[2]}`
      } else {
        new_path = path.replace(/^\/[^/]+/, `/${selectedWorkspaceId}`)
      }

      // Drop query params — they belong to the previous account's state
      // (e.g. page=2, quickFilter, search terms)
    } else {
      new_path = "/onboarding/workspaces/new"
    }

    this.anchorTarget.href = new_path
    this.anchorTarget.click()
  }
}
